import { z } from 'zod';

const extraItemSchema = z.object({
  name: z.string(),
  item_choice_id: z.number(),
  is_in_cart: z.boolean(),
  addon_required: z.boolean().nullish().transform((value) => value ?? false),
  level: z.number().optional(),
  addon_levels: z.array(
    z.object({
      addon_level_id: z.number(),
      amount: z.number(),
      is_in_cart: z.boolean(),
      name: z.string(),
      is_default: z.boolean().nullish().transform((value) => value ?? false),
    }),
  ),
});

export type ExtraItem = z.infer<typeof extraItemSchema>;

export const extraItemServiceDataSchema = z
  .object({
    calories: z.number(),
    category_id: z.number().nullable(),
    category_name: z.string().nullable(),
    created_at: z.string(),
    description: z.string(),
    diet: z.object({
      diet_id: z.number(),
      name: z.string(),
    }),
    image_url: z.string().nullable(),
    is_available_now: z.boolean(),
    is_in_cart: z.boolean(),
    item_choices: z.array(extraItemSchema),
    menu_item_id: z.number(),
    name: z.string(),
    price: z.number(),
    restaurant_id: z.number(),
    unit_price: z.number(),
  })
  .strict();

export type TExtraItemServiceDataSchema = z.infer<typeof extraItemServiceDataSchema>;
